import { Col, Row } from 'antd';
import { Link } from 'react-admin';
import React, { useCallback, useEffect, useState } from 'react';

import { Credit, User } from '@types';
import { creditHttp, CreditsByUserLiteParams } from '@network';
import { useIsMounted } from '@hooks';
import { centsFormatter, dateFormatter } from '@utils';
import { CreditStatusField } from '@pages/credit/CreditStatusField';
import cls from './user-initial.module.css';


interface UserCreditProps {
  credit: Credit;
}

interface UserCreditsProps {
  user: User;
}

const UserCredit = ({ credit }: UserCreditProps) => {
  return (
    <>
      <Col xs={12} sm={8} md={6} className={cls.infolineCard}>
        <Link to={`/credit/${credit.id}?initial`}>
          <div className={cls.credit}>
            <div className={cls.creditCode}>{credit.code}</div>
            <div className={cls.creditDate}>
              <div>Signature at: {credit.signatureAt ? dateFormatter.toDate(credit.signatureAt) : '-'}</div>
            </div>
            <div className={cls.creditBalance}>Balance</div>
            <div className={cls.creditAmount}>
              {centsFormatter.format(credit.balance)}
            </div>
            <div className={cls.creditBalance}>Requested amount</div>
            <div className={cls.creditAmount}>
              {centsFormatter.format(credit.requestAmount || 0)}
            </div>
            <div className={cls.creditCrop}>Financed crop: {credit.financedCrop?.nameMx || '-'}</div>
            <CreditStatusField
              source="status"
              creditStatus={credit.status}
              className={cls.creditStatus}
            />
          </div>
        </Link>
      </Col>
    </>);
};

export const UserCredits = ({ user }: UserCreditsProps) => {
  const [credits, setCredits] = useState<Credit[]>([]);
  const isMounted = useIsMounted();

  const loadCredits = useCallback(async () => {
    if (!isMounted.current) return;
    const params: CreditsByUserLiteParams = {
      userId: user.id,
      isAdminDraft: true,
      verqorCredit: 'mixed',
    };
    const nextCredits = await creditHttp.getCreditsLiteByUser(params);
    isMounted.current && setCredits(nextCredits);
  }, []);

  useEffect(() => {
    void loadCredits();
  }, [loadCredits, user.id]);

  return (<Row gutter={[20, 20]} className={cls.infoline}>
    {(credits || []).map(credit => (<UserCredit key={credit.id} credit={credit} />))}
  </Row>);
};
